// Named export for Composition API
export function setError(err, prevent, actionEv) {
  const status = err?.response?.status;

  if (!status || status >= 500) {
    err = {
      response: {
        status: "500",
        statusText: "server_error",
      },
    };
  }
  const response = err?.response;
  document.dispatchEvent(
    new CustomEvent("error-" + response.status, {
      detail: {
        preventDefault: Boolean(prevent),
        callbackEvent: actionEv,
        data: response,
      },
    }),
  );
}

// Default export for Options API (backward compatibility)
export default {
  methods: {
    setError,
  },
};
